import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';
import {
  IContractorAreaRequestDTO,
  ErrorDetails
} from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandParameters } from 'app/services/authentication/connection/iCommandParameters';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';

export class UpdateContractorAreaCommand extends IRequestCommand<
  IUpdateContractorAreaResponse,
  ErrorDetails,
  IUpdateContractorAreaCommandRequest
> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;

  public  setIds(contractor: number, id: number) {
    this.urlSections.push('contractorsAreas');
    this.urlSections.push(`${contractor}`);
    this.urlSections.push('update');
    this.urlSections.push(`${id}`);
    this.composeUrl();
  }
  public setCommandBody(body: IUpdateContractorAreaCommandRequest): void {
    this._commandBody = body;
  }
}

export interface IUpdateContractorAreaCommandRequest
  extends IContractorAreaRequestDTO,
    ICommandParameters {}

export interface IUpdateContractorAreaResponse extends ICommandResponse {
  id: number;
}
